import React from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import IFilter from "models/IFilter";
import Input from "components/Input";
import Select from "components/Select";
import DetailView from "components/DetailView";
import RangeDatepicker from "components/RangeDatepicker";
import Button from "components/Button";
import FilterGenerator from "helpers/filter";
import withFilters from "helpers/withFilters";
import { CUSTOM_SETTINGS } from "constants/.";

interface IProps extends IFilter {
  typeOptions: any[];
}

class InspectionReportSearch extends React.Component<IProps> {
  public static getInputQuery = value => {
    const Q = new FilterGenerator();

    Q.and("Number", value);
    Q.or("SupplierName", value);

    return Q.query;
  };

  public static getFilterQuery = f => {
    const Q = new FilterGenerator();

    if (!_.isEmpty(f.date)) {
      Q.and("Date", f.date, "dateRange");
    }
    Q.and("Number", f.number);
    Q.and("SupplierName", f.supplierName);
    Q.and("OrderNumber", f.orderNumber);
    Q.and("TypeId", f.type && f.type.value, "string");

    return Q.query;
  };

  public render = () => {
    const {
      filter,
      handleFilterChange,
      generateFilter,
      resetFilter,
      typeOptions
    } = this.props;

    return (
      <DetailView
        pageName={CUSTOM_SETTINGS.inspectionReport}
        renderExpanded={() => (
          <div>
            <div className="filter-row">
              <div className="inner-block">
                <FormattedMessage id="INSPECTION_TYPE" tagName="label" />
                <Select
                  options={typeOptions}
                  selectedOption={filter.type}
                  onChange={value => handleFilterChange(value, "type")}
                />
              </div>
              <Input
                label="ORDERS_NUMBER"
                value={filter.orderNumber}
                onChange={e =>
                  handleFilterChange(e.target.value, "orderNumber")
                }
              />
            </div>
            <div className="filter-row">
              <RangeDatepicker
                name="date"
                label="DATE"
                value={filter.date}
                handleRangeChange={handleFilterChange}
              />
            </div>
          </div>
        )}
      >
        <div className="filter-row">
          <Input
            label="RECEIPTS_NR"
            value={filter.number}
            onChange={e => handleFilterChange(e.target.value, "number")}
          />
          <Input
            label="RECEIPTS_SUPPLIER"
            value={filter.supplierName}
            onChange={e => handleFilterChange(e.target.value, "supplierName")}
          />
        </div>
        <div className="search-btn">
          <Button onClick={resetFilter}>RESET</Button>
          <Button kind="primary" onClick={generateFilter}>
            SEARCH
          </Button>
        </div>
      </DetailView>
    );
  };
}

export default withFilters({
  placeholder: "INSPECTION_SEARCH",
  pageName: CUSTOM_SETTINGS.inspectionReport
})(InspectionReportSearch);
